import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import clsx from 'clsx';
import { useFormik } from 'formik';
import queryString from 'query-string';

import { isEmpty } from 'lodash';

import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import BobLoadingMask from '../../../../components/BobLoadingMask';
import AddNewAreaModal from '../../Modals/AddNewAreaModal';
import BobClientSelector from '../../../../components/BobClientSelector';
import BobConfirmButton from '../../../../components/BobConfirmButton';
import BobCancelButton from '../../../../components/BobCancelButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import EquipmentTabContainer from './EquipmentTabContainer';
import AddNewSystemModal from '../../Modals/AddNewSystemModal';
import BobSiteSelector from '../../../../components/BobSiteSelector';
import EquipmentEnergyValidation from './EquipmentEnergyValidation';

import * as EnergyActions from '../../../../actions/energyActions';
import * as K2ACoreActions from '../../../../actions/k2aCoreActions';

import * as classes from './ManageEquipmentPage.module.css';

const ManageEquipmentPage = ({
    activeNavClient,
    activeNavCompany,
    activeNavSite,
    areas,
    equipmentTypes,
    currentUser,
    customAttributes,
    createCoreEquipment,
    entities,
    fetchCampuses,
    fetchCoreAreas,
    fetchCoreContacts,
    fetchCoreEquipmentById,
    fetchSensorsByParentId,
    fetchSystems,
    history,
    linkEquipmentToArea,
    linkEquipmentToSystem,
    navClients,
    navSites,
    manufacturers,
    selectedEquipment,
    setCoreEquipment,
    setCoreEquipments,
    sources,
    systems,
    unlinkEquipmentToArea,
    unlinkEquipmentToSystem,
    updateCoreEquipment,
    updateSensorAttributes,
    ...props
}) => {
    const [isAddNewAreaModalOpen, setIsAddNewAreaModalOpen] = useState(false);
    const [isAddNewSystemModalOpen, setIsAddNewSystemModalOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [selectedAreas, setSelectedAreas] = useState([]);
    const [selectedSystems, setSelectedSystems] = useState([]);
    const [availableSensors, setAvailableSensors] = useState([]);
    const [energyValue, setEnergyValue] = useState(null);
    const [equipmentAttributes, setEquipmentAttributes] = useState([]);
    const [sensorAttributes, setSensorAttributes] = useState([]);
    const [sensors, setSensors] = useState([]);
    const [hasValidated, setHasValidated] = useState(false);

    const queryValues = queryString.parse(history.location.search);

    useEffect(() => {
        return () => {
            const { pathname } = history.location;
            let updatedUrl = history.location.search.replace(/[?&]entityType=[^&]+/, '').replace(/^&/, '?');
            updatedUrl = updatedUrl.replace(/[?&]entityId=[^&]+/, '').replace(/^&/, '?');
            setCoreEquipment({});
            history.push({ pathname, search: updatedUrl });
        };
    }, []);

    useEffect(() => {
        const init = async () => {
            let filter = ['status', 'command', 'occupancy'];

            const site = selectedEquipment.extendedData ? selectedEquipment.extendedData.site[0] : null;
            let sensorList = [];

            if (site) {
                sensorList = await fetchSensorsByParentId(site.id, selectedEquipment.id);
                setAvailableSensors(sensorList);
            }

            formik.setFieldValue('name', selectedEquipment.name, false);
            formik.setFieldValue('equipmentType', selectedEquipment.equipmentType ? selectedEquipment.equipmentType.id : '', false);
            formik.setFieldValue('manufacturer', selectedEquipment.manufacturer ? selectedEquipment.manufacturer.id : '', false);
            formik.setFieldValue('modelNumber', selectedEquipment.model, false);
            formik.setFieldValue('serialNumber', selectedEquipment.serialNumber, false);
            if (selectedEquipment.extendedData) {
                formik.setFieldValue('client', selectedEquipment.extendedData.client ? selectedEquipment.extendedData.client[0] : '', false);
                formik.setFieldValue('site', selectedEquipment.extendedData.site ? selectedEquipment.extendedData.site[0] : '', false);
                formik.setFieldValue('area', selectedEquipment.extendedData.areas || [], false);
                formik.setFieldValue('system', selectedEquipment.extendedData.systems || [], false);

                setSelectedAreas(selectedEquipment.extendedData.areas || []);
                setSelectedSystems(selectedEquipment.extendedData.systems || []);
            }

            //Loop through sensors, find all configured sensors
            const updatedSensors = [...sensors];
            sensorList.forEach(sensor => {
                const sensorAtt = sensor.customAttributes;
                if (sensorAtt.find(item => item.customAvp.attributeName === 'load')) {
                    let energyValueAttribute = '';
                    let powerValueAttribute = '';

                    if (sensor.displayDataType === 'boolean' && filter.some(x => sensor.sensorType.name.toLowerCase().includes(x))) {
                        energyValueAttribute = 'statusValue';
                    } else {
                        energyValueAttribute = 'energyValue';
                    }

                    const energyUnitAttribute = sensorAtt.find(item => item.customAvp.attributeName === 'energyUnit');
                    if (energyUnitAttribute && energyUnitAttribute.attributeValue === 'Amps') {
                        powerValueAttribute = sensorAtt.find(item => item.customAvp.attributeName === 'current');
                    } else {
                        powerValueAttribute = sensorAtt.find(item => item.customAvp.attributeName === 'power');
                    }

                    const efficiencyAttribute = sensorAtt.find(item => item.customAvp.attributeName === 'efficiency');
                    const loadAttribute = sensorAtt.find(item => item.customAvp.attributeName === 'load');
                    const voltsAttribute = sensorAtt.find(item => item.customAvp.attributeName === 'voltage');
                    const powerFactorAttribute = sensorAtt.find(item => item.customAvp.attributeName === 'powerFactor');
                    const phaseAttribute = sensorAtt.find(item => item.customAvp.attributeName === 'phase');
                    let unitPayload = {};
                    if (energyUnitAttribute) {
                        unitPayload = { id: energyUnitAttribute.customAvp.avpId, name: energyUnitAttribute.customAvp.attributeValue };
                    }

                    updatedSensors.push({
                        energyValue:  energyValueAttribute,
                        powerUnit:    energyUnitAttribute ? energyUnitAttribute.customAvp.attributeValue : 'Watts',
                        unit:         unitPayload,
                        powerValue:   powerValueAttribute ? powerValueAttribute.customAvp.attributeValue : '',
                        statusSensor: sensor,
                        efficiency:   efficiencyAttribute ? efficiencyAttribute.customAvp.attributeValue : '',
                        load:         loadAttribute ? loadAttribute.customAvp.attributeValue : '',
                        volts:        voltsAttribute ? voltsAttribute.customAvp.attributeValue : '',
                        powerFactor:  powerFactorAttribute ? powerFactorAttribute.customAvp.attributeValue : '',
                        phase:        phaseAttribute ? phaseAttribute.customAvp.attributeValue === '1' ? 'singlePhase' : 'threePhase' : 'singlePhase'
                    });
                }
            });

            setSensors(updatedSensors);


            if (!isEmpty(selectedEquipment.customAttributeValuePairs)) {
                selectedEquipment.customAttributeValuePairs.forEach(item => {
                    const attributeName = item.customAvp.attributeName;
                    switch (attributeName) {
                        case 'monthlyTarget':
                            formik.setFieldValue('energyTargetValue', item.customAvp.attributeValue);
                            break;
                        default:
                            break;
                    }
                });
            }
        };


        if (!isEmpty(selectedEquipment)) {
            init();
        }
    }, [selectedEquipment]);

    useEffect(() => {
        const init = async () => {
            const queryValues = queryString.parse(history.location.search);
            if (queryValues.entityId) {
                if (isEmpty(selectedEquipment) || selectedEquipment.id !== queryValues.entityId) {
                    await fetchCoreEquipmentById(queryValues.entityId);
                }
            }
        };

        if (activeNavCompany.id) init();
    }, [activeNavCompany]);

    useEffect(() => {
        if (activeNavClient.id && isEmpty(selectedEquipment)) formik.setFieldValue('client', activeNavClient || {});
    }, [activeNavClient]);

    useEffect(() => {
        if (activeNavSite.id && isEmpty(selectedEquipment)) formik.setFieldValue('site', activeNavSite || {});
    }, [activeNavSite]);

    useEffect(() => {
        if (!isEmpty(customAttributes)) {
            setEquipmentAttributes(customAttributes.Equipment);
            setSensorAttributes(customAttributes.Sensor);
        } 
    }, [customAttributes]);

    const handleRoute = () => {
        const path = '/v2/dashboard/core/entities';

        if (history.location.state && history.location.state.returnUrl) {
            history.push(history.location.state.returnUrl);
        } else {
            history.push({ pathname: path, search: history.location.search });
        }
    };

    const validateSensors = sensors => {
        let error = false;

        sensors.forEach(item => {
            if (item.energyValue === 'statusValue') {
                if (!formik.values.energyTargetValue) error = true;

                if (item.powerUnit === 'Watts' || item.powerUnit === 'Kilowatts' || item.powerUnit === 'Horsepower') {
                    if (isEmpty(item.statusSensor) || isEmpty(item.efficiency) || isEmpty(item.load) || item.powerValue === '') {
                        error = true;
                    }
                } else if (item.powerUnit === 'Amps') {
                    if (isEmpty(item.statusSensor) || item.volts === '' || item.powerFactor === '' || isEmpty(item.efficiency) || isEmpty(item.load) || isEmpty(item.phase) || item.powerValue === '') {
                        error = true;
                    }
                } else {
                    error = true;
                }
            } else if (item.energyValue === 'energyValue') {
                if (!formik.values.energyTargetValue) error = true;

                if (item.powerUnit === 'Watts' || item.powerUnit === 'Kilowatts' || item.powerUnit === 'Horsepower') {
                    if (isEmpty(item.statusSensor) || isEmpty(item.efficiency) || isEmpty(item.load)) {
                        error = true;
                    }
                } else if (item.powerUnit === 'Amps') {
                    if (isEmpty(item.statusSensor) || item.volts === '' || item.powerFactor === '' || isEmpty(item.efficiency) || isEmpty(item.load) || isEmpty(item.phase)) {
                        error = true;
                    }
                } else {
                    error = true;
                }
            } else {
                error = true;
            }
        });

        setHasValidated(true);

        return error;
    };

    const formik = useFormik({
        initialValues: {
            sensors:           [],
            client:            !isEmpty(activeNavClient) ? activeNavClient : '',
            site:              !isEmpty(activeNavSite) ? activeNavSite : '',
            area:              [],
            system:            [],
            name:              '',
            equipmentType:     '',
            manufacturer:      '',
            modelNumber:       '',
            serialNumber:      '',
            energyTargetValue: '',
        },
        validationSchema:   EquipmentEnergyValidation,
        enableReinitialize: true,
        onSubmit:           async (values, { setSubmitting }) => {
            if (validateSensors(sensors)) return;

            const body = {
                siteId:          values.site.id,
                name:            values.name,
                equipmentTypeId: values.equipmentType,
                model:           values.modelNumber,
                serialNumber:    values.serialNumber
            };

            let sensorUpdates = [];

            if (!isEmpty(values.energyTargetValue)) {
                body.customAttributes = {};
                body.customAttributes.customAttributeValuePairs = [];

                const source = sources.find(item => item.name === 'K2A Core');
                const monthlyTargetAttribute = equipmentAttributes.find(item => item.name === 'monthlyTarget');

                const efficiencyAttribute = sensorAttributes.find(item => item.name === 'efficiency');
                const loadAttribute = sensorAttributes.find(item => item.name === 'load');
                const voltsAttribute = sensorAttributes.find(item => item.name === 'voltage');
                const powerFactorAttribute = sensorAttributes.find(item => item.name === 'powerFactor');
                const phaseAttribute = sensorAttributes.find(item => item.name === 'phase');
                const unitAttribute = sensorAttributes.find(item => item.name === 'energyUnit');
                const powerAttribute = sensorAttributes.find(item => item.name === 'power');
                const currentAttribute = sensorAttributes.find(item => item.name === 'current');

                const attributeValues = [];
                attributeValues.push({ sourceAvp: { avpId: source.id }, customAvp: { attributeId: monthlyTargetAttribute.id, attributeValue: values.energyTargetValue } });
                body.customAttributes = { customAttributeValuePairs: [...attributeValues] };

                sensors.forEach(sensor => {
                    if (sensor.energyValue === 'statusValue') {
                        const unitValue = unitAttribute.avpLookupValues.find(item => item.value === sensor.powerUnit);
                        const phaseValue = sensor.phase === 'singlePhase' ? 1 : 1.73205078;

                        //Status Sensor, Efficiency, Load, PowerUnit, Power
                        if (sensor.powerUnit === 'Watts' || sensor.powerUnit === 'Kilowatts' || sensor.powerUnit === 'Horsepower') {
                            sensorUpdates.push({ entityId: sensor.statusSensor.id, sourceAvp: { avpId: source.id }, customAvp: { avpId: unitValue.id } });
                            sensorUpdates.push({ entityId: sensor.statusSensor.id, sourceAvp: { avpId: source.id }, customAvp: { attributeId: efficiencyAttribute.id, attributeValue: sensor.efficiency } });
                            sensorUpdates.push({ entityId: sensor.statusSensor.id, sourceAvp: { avpId: source.id }, customAvp: { attributeId: loadAttribute.id, attributeValue: sensor.load } });
                            sensorUpdates.push({ entityId: sensor.statusSensor.id, sourceAvp: { avpId: source.id }, customAvp: { attributeId: powerAttribute.id, attributeValue: sensor.powerValue } });

                        //Status Sensor, Volts, Power Factor, Efficiency, Load, Phase, PowerUnit, Current
                        } else if (sensor.powerUnit === 'Amps') {
                            sensorUpdates.push({ entityId: sensor.statusSensor.id, sourceAvp: { avpId: source.id }, customAvp: { avpId: unitValue.id } });
                            sensorUpdates.push({ entityId: sensor.statusSensor.id, sourceAvp: { avpId: source.id }, customAvp: { attributeId: efficiencyAttribute.id, attributeValue: sensor.efficiency } });
                            sensorUpdates.push({ entityId: sensor.statusSensor.id, sourceAvp: { avpId: source.id }, customAvp: { attributeId: loadAttribute.id, attributeValue: sensor.load } });
                            sensorUpdates.push({ entityId: sensor.statusSensor.id, sourceAvp: { avpId: source.id }, customAvp: { attributeId: voltsAttribute.id, attributeValue: sensor.volts } });
                            sensorUpdates.push({ entityId: sensor.statusSensor.id, sourceAvp: { avpId: source.id }, customAvp: { attributeId: powerFactorAttribute.id, attributeValue: sensor.powerFactor } });
                            sensorUpdates.push({ entityId: sensor.statusSensor.id, sourceAvp: { avpId: source.id }, customAvp: { attributeId: phaseAttribute.id, attributeValue: phaseValue } });
                            sensorUpdates.push({ entityId: sensor.statusSensor.id, sourceAvp: { avpId: source.id }, customAvp: { attributeId: currentAttribute.id, attributeValue: sensor.powerValue } });
                        }
                    } else if (sensor.energyValue === 'energyValue') {
                        const unitValue = unitAttribute.avpLookupValues.find(item => item.value === sensor.powerUnit);
                        const phaseValue = sensor.phase === 'singlePhase' ? 1 : 1.73205078;

                        //Status Sensor, Efficiency, Load, PowerUnit
                        if (sensor.powerUnit === 'Watts' || sensor.powerUnit === 'Kilowatts' || sensor.powerUnit === 'Horsepower') {
                            sensorUpdates.push({ entityId: sensor.statusSensor.id, sourceAvp: { avpId: source.id }, customAvp: { avpId: unitValue.id } });
                            sensorUpdates.push({ entityId: sensor.statusSensor.id, sourceAvp: { avpId: source.id }, customAvp: { attributeId: efficiencyAttribute.id, attributeValue: sensor.efficiency } });
                            sensorUpdates.push({ entityId: sensor.statusSensor.id, sourceAvp: { avpId: source.id }, customAvp: { attributeId: loadAttribute.id, attributeValue: sensor.load } });
                        //Status Sensor, Volts, Power Factor, Efficiency, Load, Phase, PowerUnit
                        } else if (sensor.powerUnit === 'Amps') {
                            sensorUpdates.push({ entityId: sensor.statusSensor.id, sourceAvp: { avpId: source.id }, customAvp: { avpId: unitValue.id } });
                            sensorUpdates.push({ entityId: sensor.statusSensor.id, sourceAvp: { avpId: source.id }, customAvp: { attributeId: efficiencyAttribute.id, attributeValue: sensor.efficiency } });
                            sensorUpdates.push({ entityId: sensor.statusSensor.id, sourceAvp: { avpId: source.id }, customAvp: { attributeId: loadAttribute.id, attributeValue: sensor.load } });
                            sensorUpdates.push({ entityId: sensor.statusSensor.id, sourceAvp: { avpId: source.id }, customAvp: { attributeId: voltsAttribute.id, attributeValue: sensor.volts } });
                            sensorUpdates.push({ entityId: sensor.statusSensor.id, sourceAvp: { avpId: source.id }, customAvp: { attributeId: powerFactorAttribute.id, attributeValue: sensor.powerFactor } });
                            sensorUpdates.push({ entityId: sensor.statusSensor.id, sourceAvp: { avpId: source.id }, customAvp: { attributeId: phaseAttribute.id, attributeValue: phaseValue } });
                        }
                    }
                });
            }

            if (values.manufacturer) {
                body.equipmentManufacturerId = values.manufacturer;
            }

            const isUpdate = queryValues.entityId;
            setIsLoading(true);

            if (!isEmpty(sensorUpdates)) {
                const dimension = entities.find(item => item.name === 'Sensor');
                let body = { entityCustomAttributes: sensorUpdates, dimensionId: dimension.id };

                await updateSensorAttributes(body);
            }


            let isCreated;
            let promises = [];

            const areasToLink = selectedAreas && selectedEquipment.extendedData ? selectedAreas.filter(x => !selectedEquipment.extendedData.areas.some(y => y.id === x.id)) : [];
            const areasToUnlink = selectedEquipment && selectedEquipment.extendedData ? selectedEquipment.extendedData.areas.filter(x => !selectedAreas.some(y => y.id === x.id)) : [];

            const systemsToLink = selectedSystems && selectedEquipment.extendedData ? selectedSystems.filter(x => !selectedEquipment.extendedData.systems.some(y => y.id === x.id)) : [];
            const systemsToUnlink = selectedEquipment && selectedEquipment.extendedData && selectedEquipment.extendedData.systems ? selectedEquipment.extendedData.systems.filter(x => !selectedSystems.some(y => y.id === x.id)) : [];

            try {
                if (isUpdate) {
                    body.id = queryValues.entityId;
                    isCreated = await updateCoreEquipment(queryValues.entityId, body);

                    areasToLink.forEach(item => {
                        promises.push(linkEquipmentToArea(item.id, queryValues.entityId));
                    });

                    areasToUnlink.forEach(item => {
                        promises.push(unlinkEquipmentToArea(item.id, queryValues.entityId));
                    });

                    systemsToLink.forEach(item => {
                        promises.push(linkEquipmentToSystem(item.id, queryValues.entityId));
                    });

                    systemsToUnlink.forEach(item => {
                        promises.push(unlinkEquipmentToSystem(item.id, queryValues.entityId));
                    });
                } else {
                    isCreated = await createCoreEquipment(values.site.id, body);

                    areasToLink.forEach(item => {
                        promises.push(linkEquipmentToArea(item.id, queryValues.entityId));
                    });

                    systemsToLink.forEach(item => {
                        promises.push(linkEquipmentToSystem(item.id, queryValues.entityId));
                    });
                }

                setIsLoading(false);

                if (isCreated) {
                    await Promise.all(promises.map(p => p.catch(error => error)));
                    setCoreEquipments([], {});
                    handleRoute();
                }
            } catch (error) {
                setIsLoading(false);
            }
        }
    });

    useEffect(() => {
        const init = async () => {
            await Promise.all([fetchCoreAreas(formik.values.site.id), fetchSystems(formik.values.site.id)].map(p => p.catch(err => err)));
        };

        if (formik.values.site) init();
    }, [formik.values.site]);

    const MenuProps = {
        disablePortal:      true,
        getContentAnchorEl: () => null,
        PaperProps:         {
            style: {
                maxHeight: 300
            },
        },
    };

    const handleAddNewArea = () => {
        setIsAddNewAreaModalOpen(true);
    };

    const handleAddNewSystem = () => {
        setIsAddNewSystemModalOpen(true);
    };

    const handleClientChange = (event, value) => {
        if (value) {
            formik.setFieldValue('client', value, false);
        } else {
            formik.setFieldValue('client', '', false);
        }
        formik.setFieldValue('site', '', false);
        formik.setFieldValue('area', [], false);
        formik.setFieldValue('system', [], false);
    };

    const handleSiteChange = async (event, value) => {
        if (value) {
            formik.setFieldValue('site', value, false);
        } else {
            formik.setFieldValue('site', '', false);
        }
        formik.setFieldValue('area', [], false);
        formik.setFieldValue('system', [], false);
    };

    const handleAreasChange = (event, value) => {
        if (value.props.value === '') return;
        setSelectedAreas(event.target.value);
    };

    const handleSystemsChange = (event, value) => {
        if (value.props.value === '') return;
        setSelectedSystems(event.target.value);
    };

    const handleClearField = () => {
        formik.setFieldValue('manufacturer', '');
    };

    return (
        <div className={classes.ManageClientPage}>
            <div className={classes.ManagePageHeader}>
                <FormControl variant="outlined" size="small" className={classes.leftInputWrapper}>
                    <BobClientSelector
                        companyId={activeNavCompany.id}
                        value={formik.values.client}
                        errors={formik.errors.client}
                        touched={formik.touched.client}
                        handleChange={handleClientChange}
                        label="Select Client"
                        disabled={queryValues.entityId || !isEmpty(activeNavClient) ? true : false}
                        required
                    />
                </FormControl>
                <FormControl variant="outlined" size="small" className={classes.leftInputWrapper}>
                    <BobSiteSelector
                        companyId={activeNavCompany.id}
                        clientId={formik.values.client}
                        errors={formik.errors.site}
                        touched={formik.touched.site}
                        value={formik.values.site}
                        handleChange={handleSiteChange}
                        label="Select Site"
                        disabled={isEmpty(formik.values.client) || !isEmpty(activeNavSite) || queryValues.entityId ? true : false}
                        required
                    />
                </FormControl>
            </div>
            <div className={classes.ManagePageTitle}>
                Equipment Details
            </div>
            <div className={classes.ManagePageBody}>
                <FormControl className={classes.leftInputWrapper}>
                    <TextField
                        id="name"
                        name="name"
                        type="text"
                        value={formik.values.name}
                        label={<span>Equipment Name<span className={classes.required}> *</span></span>}
                        placeholder="Enter"
                        size="small"
                        onChange={formik.handleChange}
                        InputLabelProps={{
                            classes: {
                                error:   classes.error,
                                focused: classes.labelFocused,
                                root:    classes.label
                            }
                        }}
                        InputProps={{
                            onBlur:  formik.handleBlur,
                            classes: {
                                error:     classes.cssErrorUnderline,
                                underline: classes.cssUnderline,
                                root:      classes.input
                            }
                        }}
                        variant="outlined"
                        FormHelperTextProps={{
                            classes: {
                                error: classes.error
                            }
                        }}
                        error={Boolean(formik.errors.name) && Boolean(formik.touched.name)}
                        helperText={Boolean(formik.touched.name) && formik.errors.name}
                    />
                </FormControl>
                <FormControl variant="outlined" size="small" className={classes.rightInputWrapper}>
                    <InputLabel
                        htmlFor="equipmentType"
                        classes={{
                            error:   classes.error,
                            focused: classes.labelFocused,
                            root:    classes.label
                        }}
                        error={Boolean(formik.errors.equipmentType) && Boolean(formik.touched.equipmentType)}
                    >
                        {<span>Equipment Type<span className={classes.required}> *</span></span>}
                    </InputLabel>
                    <Select
                        value={formik.values.equipmentType}
                        id="equipmentType"
                        MenuProps={MenuProps}
                        onChange={formik.handleChange}
                        name="equipmentType"
                        classes={{
                            root: classes.input
                        }}
                        inputProps={{
                            onBlur: formik.handleBlur
                        }}
                        error={Boolean(formik.errors.equipmentType) && Boolean(formik.touched.equipmentType)}
                    >
                        {
                            equipmentTypes.map(type =>
                                <MenuItem
                                    key={type.id}
                                    value={type.id}
                                >
                                    {type.name}
                                </MenuItem>
                            )
                        }
                    </Select>
                    {formik.touched.equipmentType &&
                        formik.errors.equipmentType && <FormHelperText className={classes.error}>{formik.errors.equipmentType}</FormHelperText>}
                </FormControl>
                <FormControl variant="outlined" size="small" className={classes.leftInputWrapper}>
                    <InputLabel
                        htmlFor="manufacturer"
                        classes={{
                            error:   classes.error,
                            focused: classes.labelFocused,
                            root:    classes.label
                        }}
                        error={Boolean(formik.errors.manufacturer) && Boolean(formik.touched.manufacturer)}
                    >
                        {<span>Manufacturer</span>}
                    </InputLabel>
                    <Select
                        value={formik.values.manufacturer}
                        id="manufacturer"
                        MenuProps={MenuProps}
                        onChange={formik.handleChange}
                        name="manufacturer"
                        classes={{
                            root: classes.input
                        }}
                        endAdornment={
                            !isEmpty(formik.values.manufacturer) ?
                                <InputAdornment position="end">
                                    <span role="none" onClick={() => handleClearField()} className={clsx('material-icons-outlined md-18', classes.cancelIcon)}>
                                        close
                                    </span>
                                </InputAdornment>
                                :
                                null
                        }
                        inputProps={{
                            onBlur: formik.handleBlur
                        }}
                        error={Boolean(formik.errors.manufacturer) && Boolean(formik.touched.manufacturer)}
                    >
                        {
                            manufacturers.map(manufacturer =>
                                <MenuItem
                                    key={manufacturer.id}
                                    value={manufacturer.id}
                                >
                                    {manufacturer.name}
                                </MenuItem>
                            )
                        }
                    </Select>
                    {formik.touched.manufacturer &&
                        formik.errors.manufacturer && <FormHelperText className={classes.error}>{formik.errors.manufacturer}</FormHelperText>}
                </FormControl>
                <FormControl className={classes.leftInputWrapper}>
                    <TextField
                        id="modelNumber"
                        name="modelNumber"
                        type="text"
                        value={formik.values.modelNumber}
                        label={<span>Model Number</span>}
                        placeholder="Enter"
                        size="small"
                        onChange={formik.handleChange}
                        InputLabelProps={{
                            classes: {
                                error:   classes.error,
                                focused: classes.labelFocused,
                                root:    classes.label
                            }
                        }}
                        InputProps={{
                            onBlur:  formik.handleBlur,
                            classes: {
                                error:     classes.cssErrorUnderline,
                                underline: classes.cssUnderline,
                                root:      classes.input
                            }
                        }}
                        variant="outlined"
                        FormHelperTextProps={{
                            classes: {
                                error: classes.error
                            }
                        }}
                        error={Boolean(formik.errors.modelNumber) && Boolean(formik.touched.modelNumber)}
                        helperText={Boolean(formik.touched.modelNumber) && formik.errors.modelNumber}
                    />
                </FormControl>
                <FormControl className={classes.leftInputWrapper}>
                    <TextField
                        id="serialNumber"
                        name="serialNumber"
                        type="text"
                        value={formik.values.serialNumber}
                        label={<span>Serial Number</span>}
                        placeholder="Enter"
                        size="small"
                        onChange={formik.handleChange}
                        InputLabelProps={{
                            classes: {
                                error:   classes.error,
                                focused: classes.labelFocused,
                                root:    classes.label
                            }
                        }}
                        InputProps={{
                            onBlur:  formik.handleBlur,
                            classes: {
                                error:     classes.cssErrorUnderline,
                                underline: classes.cssUnderline,
                                root:      classes.input
                            }
                        }}
                        variant="outlined"
                        FormHelperTextProps={{
                            classes: {
                                error: classes.error
                            }
                        }}
                        error={Boolean(formik.errors.serialNumber) && Boolean(formik.touched.serialNumber)}
                        helperText={Boolean(formik.touched.serialNumber) && formik.errors.serialNumber}
                    />
                </FormControl>
            </div>
            <div className={classes.ManagePageCampus}>
                <div className={classes.CampusTitle}>
                    Area & System Details
                </div>
                <FormControl variant="outlined" size="small" className={classes.leftInputWrapper}>
                    <InputLabel
                        htmlFor="area"
                        classes={{
                            error:   classes.error,
                            focused: classes.labelFocused,
                            root:    classes.label
                        }}
                        error={Boolean(formik.errors.area) && Boolean(formik.touched.area)}
                    >
                        Area
                    </InputLabel>
                    <Select
                        disabled={isEmpty(formik.values.client) || isEmpty(formik.values.site)}
                        value={areas.filter(x => selectedAreas.some(y => y.id === x.id))}
                        id="area"
                        multiple
                        MenuProps={MenuProps}
                        onChange={handleAreasChange}
                        name="area"
                        renderValue={(selected) => selected.map(item => item.name).join(', ')}
                        classes={{
                            root: classes.input
                        }}
                        inputProps={{
                            onBlur: formik.handleBlur
                        }}
                        error={Boolean(formik.errors.area) && Boolean(formik.touched.area)}
                    >
                        <MenuItem
                            key={0}
                            value={''}
                            onClick={handleAddNewArea}
                        >
                            <span className={clsx('material-icons-outlined md-18', classes.Icon)}>
                                add
                            </span>
                            Add New Area
                        </MenuItem>
                        {
                            areas.map(area =>
                                <MenuItem
                                    key={area.id}
                                    value={area}
                                >
                                    <Checkbox style={{ color: 'black' }} checked={selectedAreas.map(area => area.id).indexOf(area.id) > -1} />
                                    <ListItemText className={classes.MenuItem} primary={area.name} />
                                </MenuItem>
                            )
                        }
                    </Select>
                    {formik.touched.area &&
                        formik.errors.area && <FormHelperText className={classes.error}>{formik.errors.area}</FormHelperText>}
                </FormControl>
                <FormControl variant="outlined" size="small" className={classes.rightInputWrapper}>
                    <InputLabel
                        htmlFor="system"
                        classes={{
                            error:   classes.error,
                            focused: classes.labelFocused,
                            root:    classes.label
                        }}
                        error={Boolean(formik.errors.system) && Boolean(formik.touched.system)}
                    >
                        System
                    </InputLabel>
                    <Select
                        disabled={isEmpty(formik.values.client) || isEmpty(formik.values.site)}
                        value={systems.filter(x => selectedSystems.some(y => y.id === x.id))}
                        id="system"
                        multiple
                        MenuProps={MenuProps}
                        onChange={handleSystemsChange}
                        name="system"
                        renderValue={(selected) => selected.map(item => item.name).join(', ')}
                        classes={{
                            root: classes.input
                        }}
                        inputProps={{
                            onBlur: formik.handleBlur
                        }}
                        error={Boolean(formik.errors.system) && Boolean(formik.touched.system)}
                    >
                        <MenuItem
                            key={0}
                            onClick={handleAddNewSystem}
                            value={''}
                        >
                            <span className={clsx('material-icons-outlined md-18', classes.Icon)}>
                                add
                            </span>
                            Add New System
                        </MenuItem>
                        {
                            systems.map(system =>
                                <MenuItem
                                    key={system.id}
                                    value={system}
                                >
                                    <Checkbox style={{ color: 'black' }} checked={selectedSystems.map(system => system.id).indexOf(system.id) > -1} />
                                    <ListItemText className={classes.MenuItem} primary={system.name} />
                                </MenuItem>
                            )
                        }
                    </Select>
                    {formik.touched.system &&
                        formik.errors.system && <FormHelperText className={classes.error}>{formik.errors.system}</FormHelperText>}
                </FormControl>
            </div>
            <div className={classes.InfoPanel}>
                {
                    !isEmpty(currentUser.email) && (currentUser.isSuperUser || currentUser.email.toLowerCase().includes('@key2act.com')) ?
                        <EquipmentTabContainer
                            availableSensors={availableSensors}
                            energyValue={energyValue}
                            sensorAttributes={sensorAttributes}
                            equipmentAttributes={equipmentAttributes}
                            setEnergyValue={setEnergyValue}
                            formik={formik}
                            sensors={sensors}
                            setSensors={setSensors}
                            hasValidated={hasValidated}
                        />
                        :
                        null
                }
            </div>
            <div className={classes.ManagePageButtons}>
                <BobCancelButton
                    onClick={handleRoute}
                    disabled={formik.isSubmitting}
                    className={classes.CancelButton}
                    label={'Cancel'}
                />
                <BobConfirmButton
                    onClick={formik.handleSubmit}
                    disabled={formik.isSubmitting}
                    className={isLoading ? classes.DisabledButtons : classes.Buttons}
                    isLoading={isLoading}
                    label={'Save'}
                    iconSize={15}
                />
            </div>
            {
                isEmpty(selectedEquipment) && queryValues.entityId ?
                    <BobLoadingMask />
                    :
                    null
            }
            {
                isAddNewAreaModalOpen ?
                    <AddNewAreaModal
                        client={formik.values.client}
                        site={formik.values.site}
                        setIsAddNewAreaModalOpen={setIsAddNewAreaModalOpen}
                    />
                    :
                    null
            }
            {
                isAddNewSystemModalOpen ?
                    <AddNewSystemModal
                        client={formik.values.client}
                        site={formik.values.site}
                        setIsAddNewSystemModalOpen={setIsAddNewSystemModalOpen}
                    />
                    :
                    null
            }
        </div>
    );
};

const mapStateToProps = state => {
    return {
        activeNavClient:   state.bob.activeNavClient,
        activeNavCompany:  state.bob.activeNavCompany,
        activeNavSite:     state.bob.activeNavSite,
        areas:             state.k2aCore.areas,
        currentUser:       state.currentUser,
        customAttributes:  state.attributeManagement.customAttributes,
        entities:          state.attributeManagement.entities,
        equipmentTypes:    state.equipmentTypes.data,
        navClients:        state.bob.navClients,
        navSites:          state.bob.navSites,
        manufacturers:     state.architect.manufacturers,
        selectedEquipment: state.k2aCore.selectedEquipment,
        sources:           state.attributeManagement.sources,
        systems:           state.k2aCore.siteSystems
    };
};

const mapDispatchToProps = {
    ...EnergyActions,
    ...K2ACoreActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ManageEquipmentPage));
